/* eslint-disable */
import axios from 'axios';
import Cookies from 'js-cookie';
import toast from 'react-hot-toast';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = Cookies.get('sc_Token');
    config.headers = {
      ...config.headers,
      Accept: 'application/json',
      Authorization: token ? `Bearer ${token}` : '',
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    };
    return config;
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      console.log(error.response);
      if (error.response.status === 401 || error.response?.data?.message === 'Forbidden access') {
        toast.error('Session expired. Please login again.');
        Cookies.remove('sc_Token');
        localStorage.clear();
        setTimeout(() => {
          window.location.href = '/';
        }, 1000);
      }
      return Promise.reject(error.response.data);
    }
    return Promise.reject(error);
  },
);

const api = {
  
  login: async (data) => {
    try {
      const response = await axiosInstance.post('/user/login', data);
      return response.data;
    } catch (error) {
      console.error('Error logging in:', error);  
      throw error;
    }
  },
  verifyLogin2FA: async (data) => {
    try {
      const response = await axiosInstance.post('/user/verify-2fa', data);
      return response.data;
    } catch (error) {
      console.error('Error verifying 2FA:', error);
      throw error;
    }
  },
  signup: async (data) => {
    try {
      const response = await axiosInstance.post('/auto-onboard/signup', data);
      return response.data;
    } catch (error) {
      console.error('Error signing up:', error);
      throw error;
    }
  },
  getVisitorInfo: async () => {
    try {
      const geo = await axios.get('https://ipinfo.io/json');
      return {
        ip: geo.data?.ip || '',
        country: geo.data?.country || '',
      };
    } catch (err) {
      return { ip: '', country: '' };
    }
  },
  // Used when EMAIL_ONLY_SIGNUP is true. Swap back to `signup` to revert.
  signupWithEmail: async (data) => {
    try {
      const webhookUrl = 'https://hooks.slack.com/services/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';

      // no-cors: Slack webhooks don't return CORS headers; request still delivers
      await fetch(webhookUrl, {
        method: 'POST',
        mode: 'no-cors',
        body: JSON.stringify({
          text: `New SalesCaptain signup request\n*Name:* ${data.name}\n*Email:* ${data.email}\n*Phone:* ${data.phone}\n*IP:* ${data.ip || ''}\n*Country:* ${data.country || ''}`,
          name: data.name,
          email: data.email,
          phone: data.phone,
          ip: data.ip || '',
          country: data.country || '',
        }),
      });

      return {
        status: 'success',
        message: 'Thanks! We received your signup request. our team will contact you soon.',
      };
    } catch (error) {
      console.error('Error signing up with email:', error);
      throw error;
    }
  },
  verifyOTP: async (id, token1, data) => {
    try {
      const response = await axios.post(`${BASE_URL}/auto-onboard/verify-email/${id}`, data, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token1}`,
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error verifying OTP:', error);
      throw error;
    }
  },
  
  fetchNumber: async (user_id, data) => {
    try {
      const response = await axiosInstance.post(`/auto-onboard/fetch-twilio-numbers/${user_id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error fetching number:', error);
      throw error;
    }
  },
  updateUserDetails: async (user_id, data) => {
    try {
      const response = await axiosInstance.post(`/auto-onboard/pre-onboard/${user_id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error fetching user details:', error); 
      throw error;
    }
  },
  getUserDetails: async (user_id) => {
    try {
      const response = await axiosInstance.get(`/auto-onboard/fetch-company/${user_id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching user details:', error); 
      throw error;
    }
  },
  getPaymentLink: async (account_id, data) => {
    try {
      const response = await axiosInstance.post(`/auto-onboard/get-payment-link/${account_id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error fetching payment link:', error); 
      throw error;
    }
  },
  googleSignup: async () => {
    try {
      const response = await axiosInstance.get('/integration/google-signup-connect');
      return response.data;
    } catch (error) {
      console.error('Error signing up with Google:', error);
      throw error;
    }
  },
  googleSignupCallback: async (code) => {
    try {
      const response = await axiosInstance.get(`/integration/auth/google-signup/callback?code=${code}`);
      return response.data;
    } catch (error) {
      console.error('Error signing up with Google:', error);
      throw error;
    }
  },
  googleLogin: async () => {
    try {
      const response = await axiosInstance.get('/integration/google-login-connect');
      return response.data;
    } catch (error) {
      console.error('Error signing up with Google:', error);
      throw error;
    }
  },
  googleLoginCallback: async (code) => {
    try {
      const response = await axiosInstance.get(`/integration/auth/google-login/callback?code=${code}`);
      return response.data;
    } catch (error) {
      console.error('Error signing up with Google:', error);
      throw error;
    }
  },

  sendOptToPhone: async (data) => {
    try {
      const response = await axiosInstance.post(`/auto-onboard/generate-startup-otp/${data.company_id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error sending OTP to phone:', error);
      throw error;
    }
  },
  
  verifyPhoneNumber: async (data) => {
    try {
      const response = await axiosInstance.post(`/auto-onboard/verify-startup-otp/${data.company_id}/${data.user_id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error verifying phone number:', error);
      throw error;
    }
  },
  submitEnterprisePlan: async (data) => {
    try {
      const response = await axiosInstance.post(`/auto-onboard/enterprise-submission/${data.user_id}/${data.company_id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error submitting enterprise plan:', error);
      throw error;
    }
  },
  
  forgotPassword: async (data) => {
    try {
      const response = await axiosInstance.post('/user/check-forget-password', data);
      return response.data;
    } catch (error) {
      console.error('Error sending forgot password request:', error);
      throw error;
    }
  },

};

export default api; 